import http from '@services/http'
import { IPopularSearchTerm, IPopularSearchTermNews } from '@protocol/popularSearchTerm'

class PopularSearchTermApi {
  async fetchPopularSearchTerms(params: IPopularSearchTerm.Params): Promise<IPopularSearchTerm.Schema> {
    return http.get('popularSearchTerm/fetchPopularSearchTerms', params || {})
  }

  async fetchPopularSearchTermNews(params: IPopularSearchTermNews.Params): Promise<IPopularSearchTermNews.Schema> {
    return http.get('popularSearchTerm/fetchPopularSearchTermNews', params || {})
  }
}

export default new PopularSearchTermApi()
